<div class="otp-container">
  <div class="otp-and-logo">
    <img src="../../../../assets/images/logos/autoverse-logo-with-text-removebg-preview.png" />

    <!-- Mobile Number Card -->
    <div class="otp-card" *ngIf="!otpSent">
      <h2>Verify your mobile number</h2>
      <p class="subtitle">
        For claim approval, we’ll send a 4-digit OTP to your phone.
      </p>

      <div class="mbl-input-with-error-txt">
        <div class="mobile-input">
          <span class="country-code">+91</span>
          <input
            type="tel"
            maxlength="10"
            placeholder="Enter 10-digit mobile"
            [(ngModel)]="mobileNumber"
            class="black-placeholder"
          />
        </div>
        <div class="error-msg-mbl-number">
          <span *ngIf="showError">Please enter 10 digits</span>
        </div>
      </div>

      <div class="info-text">
        <span>You’ll get an SMS OTP.</span>
        <!-- <a href="#" class="help-link">Need help?</a> -->
      </div>

      <button  #getOtpButton
        class="btn-otp"
        [ngStyle]="{
          'background': isValidNumber ? 'linear-gradient(to right, #144579, #257FDF)' : '#ccc'
        }"
        (click)="getOtp()"
      >
        Get OTP
      </button>


      <p class="terms">By continuing, you agree to verification via SMS.</p>
    </div>

    <!-- OTP Verification Card -->
    <div class="otp-card" *ngIf="otpSent">
      <h2>Enter the 4-digit OTP</h2>
      <p class="subtitle">
        Sent to +91{{ mobileNumber }}
        <a href="#" class="help-link" (click)="changeNumber()" style="color: #144579;font-weight: 500">Change</a>
      </p>

      <div class="otp-inputs">
        <input type="text" maxlength="1"
          [(ngModel)]="otp[0]"
          (input)="autoFocus($event,1)"
          (keydown)="onOtpKeydown($event,0)" />

        <input type="text" maxlength="1"
          [(ngModel)]="otp[1]"
          (input)="autoFocus($event,2)"
          (keydown)="onOtpKeydown($event,1)" />

        <input type="text" maxlength="1"
          [(ngModel)]="otp[2]"
          (input)="autoFocus($event,3)"
          (keydown)="onOtpKeydown($event,2)" />

        <input type="text" maxlength="1"
          [(ngModel)]="otp[3]"
          (keydown)="onOtpKeydown($event,3)" />
      </div>
      
        <div class="resend-text">
        <span>Resend in {{ timer | number: '2.0' }}s</span>
        <a href="#" class="help-link" (click)="resendOtp()" *ngIf="timer === 0">Resend OTP</a>
        </div>

      <button #verifyOtpButton
        class="btn-otp" 
        [ngStyle]="{ 'background': isValidNumber ? 'linear-gradient(to right, #144579, #257FDF)' : '#ccc' }"
        (click)="verifyOtp()"
        >
        Verify & Continue
      </button>

      <p class="terms">By continuing, you agree to verification via SMS.</p>
    </div>
  </div>
</div>
